import { Box, Grid } from "@mui/material";
import { Field, Form, Formik } from "formik";
import React from "react";
import { Inputs } from "../formInputs";
import * as Yup from "yup";
import { useSelector } from "../../store";

interface Props {
  handleSubmit: (values: { note: string }) => void;
}

const AddJobNoteForm: React.FC<Props> = (props) => {
  const { handleSubmit } = props;
  const { job, status } = useSelector((store) => store.job);
  const validationSchema = Yup.object().shape({
    note: Yup.string().required("Required").typeError("Required"),
  });

  return (
    <Box>
      <Formik
        initialValues={{ note: "" }}
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values);
          resetForm();
        }}
        validationSchema={validationSchema}
      >
        <Form noValidate>
          <Grid container direction={"column"}>
            <Grid>
              <Field
                name="note"
                label="Add New Note"
                component={Inputs.TextArea}
                disabled={job.id === 0}
              />
            </Grid>
            <Grid>
              <Grid container direction={"row"} justifyContent={"flex-end"}>
                <Grid>
                  <Inputs.Submit
                    text="Add Note"
                    disabled={job.id === 0}
                    isSubmitting={status === "loading"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default AddJobNoteForm;
